import { render } from "./UserCreationModal.vue?vue&type=template&id=5159f7fd"
import script from "./UserCreationModal.vue?vue&type=script&lang=js"
export * from "./UserCreationModal.vue?vue&type=script&lang=js"

import exportComponent from "D:\\PHPStormProjects\\hqam-customer-portal\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__